import React, { Fragment } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles'
import { injectIntl, defineMessages, FormattedMessage } from 'react-intl';
import { compose } from 'redux';
import style from './SiblingInformation.scss';
import { isMS, is2K, is3K, isK, isPK, isGTAPP } from '../../utils/helpers';
import { withRtl } from '../../components/hoc';
// waitlist app
const localMessages = defineMessages({
  heading: {
    id: 'siblinginfoquestion.heading',
    defaultMessage: 'Sibling Information',
    description: 'Sibling Information',
  },
  pk3kquestionline1: {
    id: 'siblinginfoquestion.pk3kquestionline1',
    defaultMessage: 'Does your child have one or more siblings who will be attending this school in September?',
    description: 'PK/3K Sibling Question Line 1',
  },
  pk3kquestionline2: {
    id: 'siblinginfoquestion.pk3kquestionline2',
    defaultMessage: 'An applicant’s siblings include any full-siblings, half-siblings, step-siblings, and/or foster siblings who live in the same household.',
    description: 'PK/3K Sibling Question Line 2',
  },
  pk3kquestionline3: {
    id: 'siblinginfoquestion.pk3kquestionline3',
    defaultMessage: 'For district schools or Pre-K Centers, your child will receive priority for admission if the older sibling(s) is currently pre-registered or enrolled at the school or a District 75 program in the same building in September.',
    description: 'PK/3K Sibling Question Line 3',
  },
  pk3kquestionline4: {
    id: 'siblinginfoquestion.pk3kquestionline4',
    defaultMessage: 'For NYC Early Education Centers (NYCEECs), your child will receive priority if a sibling of any age will be enrolled in a program at the same NYCEEC for September.',
    description: 'PK/3K Sibling Question Line 4',
  },
  kquestionline1: {
    id: 'siblinginfoquestion.kquestionline1',
    defaultMessage: 'Does your child have one or more siblings who will be attending this school in September?',
    description: 'K Sibling Question Line 1',
  },
  kquestionline2: {
    id: 'siblinginfoquestion.kquestionline2',
    defaultMessage: 'An applicant’s siblings include any full-siblings, half-siblings, step-siblings, and/or foster siblings who live in the same household.',
    description: 'K Sibling Question Line 2',
  },
  kquestionline3: {
    id: 'siblinginfoquestion.kquestionline3',
    defaultMessage: 'Your child will receive priority for admission if the sibling(s) is currently pre-registered or enrolled at the school or a District 75 program in the same building in September.',
    description: 'K Sibling Question Line 3',
  },
  msquestionline1: {
    id: 'siblinginfoquestion.msquestionline1',
    defaultMessage: 'If your child who is applying to middle school has a sibling who will be enrolled next year in one of the schools below, please indicate this by checking that school and providing information about that sibling. Please note that middle school programs admitting students through the audition, language criteria, talent test, or screened admissions methods do not have a sibling priority, as those programs have criteria for admission.',
    description: 'MS Sibling Question Line 1',
  },
  msquestionline2: {
    id: 'siblinginfoquestion.msquestionline2',
    defaultMessage: 'An applicant’s siblings include any full-siblings, half-siblings, step-siblings, and/or foster siblings who live in the same household.',
    description: 'MS Sibling Question Line 2',
  },
  msquestionline3: {
    id: 'siblinginfoquestion.msquestionline3',
    defaultMessage: 'Applicants will receive priority to their sibling’s school no matter where they list the school on the application. For more information, visit ',
    description: 'MS Sibling Question Line 3',
  },
})

class SiblingInformation extends React.Component {
  constructor(props) {
    super(props);
  }
  render () {
    const {endYear} = this.props;
    return (
      <div>
        { is2K(this.props) || is3K(this.props) || isPK(this.props) ? (
        <Fragment>
          <h4 className={style.additionalQuestionsHeading}><FormattedMessage {...localMessages.heading} /></h4>
          <p><FormattedMessage {...localMessages.pk3kquestionline1} values={{endYear: endYear}} /></p>
          <ul>
            <li><FormattedMessage {...localMessages.pk3kquestionline2} /></li>
            <li><FormattedMessage {...localMessages.pk3kquestionline3} values={{endYear: endYear}} /></li>
            <li><FormattedMessage {...localMessages.pk3kquestionline4} values={{endYear: endYear}} /></li>
          </ul>
        </Fragment>
      ) : null}
      {isK(this.props) ? (
        <Fragment>
          <h4 className={style.additionalQuestionsHeading}><FormattedMessage {...localMessages.heading} /></h4>
          <p><FormattedMessage {...localMessages.kquestionline1} values={{endYear: endYear}}/></p>
          <ul>
            <li><FormattedMessage {...localMessages.kquestionline2} /></li>
            <li><FormattedMessage {...localMessages.kquestionline3} values={{endYear: endYear}}/></li>
          </ul>
        </Fragment>
      ) : null}
      {isGTAPP(this.props) ? (
        <Fragment>
          <h4 className={style.additionalQuestionsHeading}><FormattedMessage {...localMessages.heading} /></h4>
          <p><FormattedMessage {...localMessages.kquestionline1} values={{endYear: endYear}}/></p>
        </Fragment>
      ) : null}
      {isMS(this.props) ? (
        <Fragment>
          <h4 className={style.additionalQuestionsHeading}><FormattedMessage {...localMessages.heading} /></h4>
          <p><FormattedMessage {...localMessages.msquestionline1} /></p>
          <ul>
            <li><FormattedMessage {...localMessages.msquestionline2} /></li>
            <li><FormattedMessage {...localMessages.msquestionline3} /> <a href="http://schools.nyc.gov/MS">schools.nyc.gov/MS</a>.</li>
          </ul>
        </Fragment>
      ) : null}
      </div>
    )
  }
}

export default compose(
  injectIntl,
  withRtl(style),
  withStyles(style),
)(SiblingInformation);